// ** React Imports
import React, { lazy, Suspense } from "react";

// ** Router Components
import { BrowserRouter as AppRouter, Route, Routes } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import SignIn from "../views/Auth/SignIn";
import SignUp from "../views/Auth/SignUp/SignUp";
import "./index.css";

import Home from "../views/Home";
import PrivacyPolicy from "../views/PrivacyPolicy";
import TermsOfService from "../views/TermsOfService";
import TermsOfSale from "../views/TermsOfSale";
import RefundPolicy from "../views/RefundPolicy";
import Documents from "../views/Documents";
import PaymentPolicy from "../views/PaymentPolicy";
import CookieTrackingPolicy from "../views/Cookie&TrackingPolicy";
import ContactComplainPolicy from "../views/ContactComplainPolicy";
import AboutUs from "../views/AboutUs";
import CartList from "../views/CartList";
import Careers from "../views/Careers";

const Error = lazy(() => import("../views/Error"));
const Menu = lazy(() => import("../views/Menu"));
const MyOrders = lazy(() => import("../views/MyOrders"));
const MyCart = lazy(() => import("../views/MyCart"));
const Contact = lazy(() => import("../views/Contact"));
// const Home = lazy(() => import("../views/Home"));
const UserProfile = lazy(() => import("../views/UserProfile"));
const OrderDetails = lazy(() => import("../views/OrderDetails"));
const OurPromisePage = lazy(() => import("../views/OurPromise"));

const Router: React.FC = () => {
  return (
    <AppRouter>
      <Suspense fallback={<div></div>}>
        <Routes>
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route path="*" element={<Error />} />


          {/* --------- Nav Bar ------------ */}
          <Route path="/" element={<MainLayout />}>
            <Route index element={<Home />} />
            <Route
              path="order"
              element={
                <div className="fade-in">
                  <Menu />
                </div>
              }
            />
            <Route path="onlineOrders" element={<MyOrders />} />
            <Route path="shoppingCart" element={<MyCart />} />
            <Route path="documents" element={<Documents />} />
            <Route
              path="contact"
              element={
                <div className="fade-in">
                  <Contact />
                </div>
              }
            />
            <Route
              path="our-promise"
              element={
                <div className="fade-in">
                  <OurPromisePage />
                </div>
              }
            />
            <Route path="profile" element={<UserProfile />} />
            <Route path="order-details" element={<OrderDetails />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="terms-of-service" element={<TermsOfService />} />
            <Route path="terms-of-sale" element={<TermsOfSale />} />
            <Route path="refund-policy" element={<RefundPolicy />} />
            <Route path="payment-policy" element={<PaymentPolicy />} />
            <Route path="cookie-tracking-policy" element={<CookieTrackingPolicy />} />
            <Route path="contact-complain-policy" element={<ContactComplainPolicy />} />

            <Route path="about-us" element={<AboutUs />} />
            <Route path="carts" element={<CartList/>} />
            <Route path="careers" element={<Careers/>} />
          </Route>
          {/* --------- Nav Bar ------------ */}
        </Routes>
      </Suspense>
    </AppRouter>
  );
};

export default Router;
